import { IBaseTextBoxEditorProps, BaseTextBoxEditor } from "../BaseTextBoxEditor";

import { INumberTextBoxSpecificProps, NumberTextBox } from "../NumberTextBox";

import { CurrencyCode } from "../../../Wrap/Constants/Enums/Domain/CurrencyCode";

import { Guid } from "../../Utils/Guid";

import * as React from "react";
import { CurrencySymbolDictionary } from "../../Enums/Dictionaries/CurrencySymbolDictionary";
import { NumericWithDot } from "../Validation/RegExPatterns";

export interface IMoneyTextBoxEditorProps
    extends IBaseTextBoxEditorProps,
        INumberTextBoxSpecificProps,
        React.Props<MoneyTextBoxEditor> {
    currency: CurrencyCode;
    alwaysValidateOnUpdate?: boolean;
    allowDecimals?: boolean;
}

export class MoneyTextBoxEditor extends BaseTextBoxEditor<IMoneyTextBoxEditorProps> {
    private _guid: string = Guid.getNext();
    private _textBoxRef: NumberTextBox;
    private _maxTextBoxLength = 20;

    constructor(props: IMoneyTextBoxEditorProps) {
        super(props);
    }

    protected getInput(): JSX.Element {
        return (
            <div className="input-group controls-money">
                <NumberTextBox
                    {...(this.props as any)}
                    ref={(ref: NumberTextBox) => (this._textBoxRef = ref)}
                    inputMode={this.props.allowDecimals ? "decimal" : "numeric"}
                    maxLength={this.props.maxLength || this._maxTextBoxLength}
                    id={this.state.inputGroupId}
                    onValidationResultChange={(isValid: boolean, errors: string[], showValidationMessages: boolean) =>
                        this.handleValidationResultChange(isValid, errors, showValidationMessages)
                    }
                    ariaDescribedby={
                        this._guid +
                        " " +
                        this._infoTextId +
                        (this.props.ariaDescribedby ? " " + this.props.ariaDescribedby : "")
                    }
                    maxNumberOfDecimalPlaces={{ errorMessage: "No more than 2 decimal places", value: 2 }}
                    ariaInvalidCanBeShown={this.state.typingFinished}
                    ariaInvalidShouldBeShown={!this.state.isValidOutside}
                    onBlur={(value) => this.onBlur(value)}
                    isCultureUsedToFormatDisplayValue={true}
                    allowedCharacters={NumericWithDot}
                    alwaysValidateOnUpdate={this.props.alwaysValidateOnUpdate}
                    allowDecimals={this.props.allowDecimals}
                />
                <span
                    className="input-text-addon symbol"
                    id={this._guid}
                    dangerouslySetInnerHTML={{ __html: CurrencySymbolDictionary.getSymbol(this.props.currency) }}
                />
            </div>
        );
    }

    public completelyRecalculateValidation(): boolean {
        return this._textBoxRef.completelyRecalculateValidation();
    }

    private onBlur(value: number): void {
        if (this.props.onBlur) {
            this.props.onBlur(value);
        }

        this.setState({ typingFinished: true });
    }

    private handleValidationResultChange(isValid: boolean, errors: string[], showValidationMessages: boolean): void {
        this.onValidationResultChange(isValid, errors, showValidationMessages);

        if (this.props.onValidation) {
            this.props.onValidation(errors);
        }
    }
}
